
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({})
export default class extends Vue {
  @Prop({ default: '.CSV' }) type!: string;
  @Prop({ default: '10' }) size!: string;
  errList: object[] = [];
  fialDialog: boolean = false;
  fileInfo: any = null;
  beforeUpLoad(file: any) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = async () => {
        let isPass = await this.uploadRules(file);
        if (!isPass) {
          reject();
        } else {
          resolve();
        }
      };
      reader.readAsDataURL(file);
    }).then(
      () => {
        return file;
      },
      () => {
        return Promise.reject();
      }
    );
  }
  uploadRules(file: any) {
    return new Promise(resolve => {
      const isLt2M = file.size / 1024 / 1024 < Number(this.size);
      const isType = file.name.substring(file.name.lastIndexOf('.'), file.name.length);
      let istype = this.type.includes(`${isType.toUpperCase()}`);
      if (!istype) {
        this.$message.error(`文件格式仅支持 ${this.type} 格式，请重新上传`);
        resolve(false);
      }
      if (!isLt2M) {
        this.$message.error(`文件大小不能超过${this.size}MB`);
        resolve(false);
      }
      resolve(true);
    });
  }
  async UploadFile(file: any) {
    this.fileInfo = file;
    this.$emit('success', file);
  }
}
